import { OrganizationPaper } from './OrganizationPaper';
export default OrganizationPaper;